import React from 'react';

import { TaxonomyFilter } from 'Components/molecules/TaxonomyFilter';

export const getTaxonomyFilter = config => (
  <TaxonomyFilter
    label={config.label || 'Show me:'}
    listModeOptions={config.listModeOptions || {
      seeMoreLabel: 'See more',
      seeLessLabel: 'See less',
      icon: 'triangle-down',
    }}
    currentPageUrl={config.currentPageUrl || ''}
    content={config.content || []}
    extraClassNames={config.extraClassNames || {}}
  />
);
